import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewChildren, HostListener } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as Chart from 'chart.js';
import { IssueService } from '../../../../services/issue.service';
import { ActivatedRoute, Route, Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issues-loan-chart',
    template: '<canvas id="basechart" #basechart *ngIf="data.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [':host { width: 100%; position: relative; display:block; }']
})
export class IssuesLoanChartComponent implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    data: any[] = [];
    labels: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {

        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');


        this.issueService.issuePaygGetLoans(this.clientId, this.siteId).then((result) => {
            let resultData = result as any;

            if (resultData.consumerNotProvidedLoansLast90Days > 0 || resultData.consumerProvidedLoansLast90Days > 0) {
                this.data = [];
                this.labels = [];
                if (result.consumerNotProvidedLoansLast90Days > 0) {
                    this.labels.push('Not provided');
                    this.data.push(result.consumerNotProvidedLoansLast90Days);
                }
               
                if (result.consumerProvidedLoansLast90Days > 0) {
                    this.labels.push('Provided');
                    this.data.push(result.consumerProvidedLoansLast90Days);
                }
                this.createChart();
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    private getChartConfig(): any {
        let config = {
            type: 'doughnut',
            options: {
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                maintainAspectRatio: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                        scaleLabel: {
                            display: true,
                            labelString: 'Amount Days',
                            fontSize: 15,
                        },
                    }],
                    yAxes: [
                        {
                            display: false,
                            scaleLabel: {
                                display: true,
                                labelString: 'Amount',
                                fontSize: 15,
                                fontStyle: "bold",
                            },
                        },
                    ]

                }
            }
        }

        return config;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        datasets.push({
            label: 'PAYG',
            data: this.data,
            backgroundColor: ['#93c01f', '#c82b2b'],
            borderColor: ['#93c01f', '#c82b2b'],
        });

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                datasets: datasets,
                labels: this.labels
            },
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }


}
